import React from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './AuthProvider';
import { useToast } from '../components/Toast';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '/api';

function LoginForm() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const toast = useToast();

  const handleGoogleSuccess = async (credentialResponse) => {
    try {
      const res = await fetch(`${API_BASE_URL}/auth/google-login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ token: credentialResponse.credential }),
      });

      if (!res.ok) {
        const errorData = await res.json();
        toast.error(`Login Failed: ${errorData.detail}`);
        return;
      }

      const data = await res.json();
      login(data.access_token, data.user);
      navigate('/');
    } catch (error) {
      console.error('Login Error:', error);
      toast.error('Login failed due to network error.');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6">
      <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-8 w-full max-w-sm">
        <h2 className="text-xl font-bold text-slate-800 mb-2 text-center">LDB Maintenance System</h2>
        <p className="text-sm text-slate-600 mb-6 text-center">
          管理権限のある Google アカウントでログインしてください。
        </p>
        <div className="flex justify-center">
          <GoogleLogin
            onSuccess={handleGoogleSuccess}
            onError={() => {
              console.log('Login Failed');
              toast.error('Google Login Failed');
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default LoginForm;
